import '@/assets/js/google-tag-metrics';
import '@/assets/js/widget-replain-scripts';
import { initYandexMetrika } from './yandex-metric-loader';

let isInitialized = false;

export const initMetrics = (lang) => {
    if (isInitialized) return;

    // Yandex Metrika is only used on the RU site (hart-estate.ru).
    // The EN site (getfloorplan.com) uses Google Analytics only.
    if (lang === 'ru') {
        const ruCounterId = 98352873;
        initYandexMetrika(ruCounterId);
    }

    isInitialized = true;
};
